module.exports = __webpack_public_path__ + "static/media/arrow.e138406d.svg";